"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AVEN_CARD_PRODUCT_TYPE_TO_AVEN_PRODUCT = exports.AVEN_PRODUCT_TO_POSSIBLE_AVEN_CARD_PRODUCT_TYPES = exports.AVEN_PRODUCT_TO_AVEN_CARD_PRODUCT_TYPE = exports.AVEN_CARD_PRODUCT_TYPE_TO_CATEGORY = exports.AvenCardProductCategory = exports.FLOOD_INSURANCE_REQUIRED_FOR_AVEN_CARD_PRODUCT_TYPE = exports.HOME_AVEN_CARD_PRODUCT_TYPES = exports.AvenCardProductType = void 0;
const avenProduct_1 = require("../avenProduct");
/**  @TranslateToPython  */
var AvenCardProductType;
(function (AvenCardProductType) {
    AvenCardProductType["_NONE"] = "NONE";
    AvenCardProductType["CRYPTO"] = "CRYPTO";
    AvenCardProductType["AUTO"] = "AUTO";
    AvenCardProductType["AUTO_REVOLVING_FIRST"] = "AUTO_REVOLVING_FIRST";
    AvenCardProductType["HOME"] = "HOME";
    AvenCardProductType["HOME_NO_LOYALTY"] = "HOME_NO_LOYALTY";
    AvenCardProductType["HOME_LIMITED_MODE"] = "HOME_LIMITED_MODE";
    AvenCardProductType["HOME_SECURED_PLUS"] = "HOME_SECURED_PLUS";
    AvenCardProductType["ASSET_ATTESTATION"] = "ASSET_ATTESTATION";
})(AvenCardProductType || (exports.AvenCardProductType = AvenCardProductType = {}));
/** @TranslateToPython */
exports.HOME_AVEN_CARD_PRODUCT_TYPES = [AvenCardProductType.HOME, AvenCardProductType.HOME_SECURED_PLUS, AvenCardProductType.HOME_NO_LOYALTY, AvenCardProductType.HOME_LIMITED_MODE];
/**
 * Whether a card product type requires active flood insurance coverage when the home is in a flood zone.
 * The `Record` forces exhaustive assignment, so any new `AvenCardProductType` must explicitly opt in or out.
 */
/** @TranslateToPython */
exports.FLOOD_INSURANCE_REQUIRED_FOR_AVEN_CARD_PRODUCT_TYPE = {
    [AvenCardProductType.HOME]: true,
    [AvenCardProductType.HOME_NO_LOYALTY]: true,
    [AvenCardProductType.HOME_SECURED_PLUS]: true,
    [AvenCardProductType.HOME_LIMITED_MODE]: false,
    [AvenCardProductType.ASSET_ATTESTATION]: false,
    [AvenCardProductType.CRYPTO]: false,
    [AvenCardProductType.AUTO]: false,
    [AvenCardProductType.AUTO_REVOLVING_FIRST]: false,
    [AvenCardProductType._NONE]: false,
};
/**
 * Coarse category for a card product type. Consumers that dispatch AUTO vs card-backed vs no-product
 * should switch on this (the `Record` forces exhaustive assignment when a new `AvenCardProductType` is added,
 * so any new enum member must pick a category rather than silently fall through).
 */
var AvenCardProductCategory;
(function (AvenCardProductCategory) {
    AvenCardProductCategory["AUTO"] = "AUTO";
    AvenCardProductCategory["CARD"] = "CARD";
    AvenCardProductCategory["NONE"] = "NONE";
})(AvenCardProductCategory || (exports.AvenCardProductCategory = AvenCardProductCategory = {}));
exports.AVEN_CARD_PRODUCT_TYPE_TO_CATEGORY = {
    [AvenCardProductType.AUTO]: AvenCardProductCategory.AUTO,
    [AvenCardProductType.AUTO_REVOLVING_FIRST]: AvenCardProductCategory.AUTO,
    [AvenCardProductType.HOME]: AvenCardProductCategory.CARD,
    [AvenCardProductType.HOME_NO_LOYALTY]: AvenCardProductCategory.CARD,
    [AvenCardProductType.HOME_LIMITED_MODE]: AvenCardProductCategory.CARD,
    [AvenCardProductType.HOME_SECURED_PLUS]: AvenCardProductCategory.CARD,
    [AvenCardProductType.ASSET_ATTESTATION]: AvenCardProductCategory.CARD,
    [AvenCardProductType.CRYPTO]: AvenCardProductCategory.CARD,
    [AvenCardProductType._NONE]: AvenCardProductCategory.NONE,
};
exports.AVEN_PRODUCT_TO_AVEN_CARD_PRODUCT_TYPE = {
    [avenProduct_1.AvenProductOrUnknown.HOME]: AvenCardProductType.HOME,
    [avenProduct_1.AvenProductOrUnknown.UCC]: AvenCardProductType.ASSET_ATTESTATION,
    [avenProduct_1.AvenProductOrUnknown.CRYPTO]: AvenCardProductType.CRYPTO,
    [avenProduct_1.AvenProductOrUnknown.AUTO]: AvenCardProductType.AUTO,
    [avenProduct_1.AvenProductOrUnknown.DEPOSIT]: AvenCardProductType._NONE,
    [avenProduct_1.AvenProductOrUnknown.MORTGAGE]: AvenCardProductType._NONE,
    [avenProduct_1.AvenProductOrUnknown.ADVISOR]: AvenCardProductType._NONE,
    [avenProduct_1.AvenProductOrUnknown.UNKNOWN]: AvenCardProductType._NONE,
};
exports.AVEN_PRODUCT_TO_POSSIBLE_AVEN_CARD_PRODUCT_TYPES = {
    [avenProduct_1.AvenProductOrUnknown.HOME]: [AvenCardProductType.HOME, AvenCardProductType.HOME_NO_LOYALTY, AvenCardProductType.HOME_LIMITED_MODE, AvenCardProductType.HOME_SECURED_PLUS],
    [avenProduct_1.AvenProductOrUnknown.UCC]: [AvenCardProductType.ASSET_ATTESTATION],
    [avenProduct_1.AvenProductOrUnknown.CRYPTO]: [AvenCardProductType.CRYPTO],
    [avenProduct_1.AvenProductOrUnknown.AUTO]: [AvenCardProductType.AUTO, AvenCardProductType.AUTO_REVOLVING_FIRST],
    [avenProduct_1.AvenProductOrUnknown.DEPOSIT]: [AvenCardProductType._NONE],
    [avenProduct_1.AvenProductOrUnknown.MORTGAGE]: [AvenCardProductType._NONE],
    [avenProduct_1.AvenProductOrUnknown.ADVISOR]: [AvenCardProductType._NONE],
    [avenProduct_1.AvenProductOrUnknown.UNKNOWN]: [AvenCardProductType._NONE],
};
exports.AVEN_CARD_PRODUCT_TYPE_TO_AVEN_PRODUCT = {
    [AvenCardProductType.HOME]: avenProduct_1.AvenProductOrUnknown.HOME,
    [AvenCardProductType.HOME_NO_LOYALTY]: avenProduct_1.AvenProductOrUnknown.HOME,
    [AvenCardProductType.HOME_LIMITED_MODE]: avenProduct_1.AvenProductOrUnknown.HOME,
    [AvenCardProductType.HOME_SECURED_PLUS]: avenProduct_1.AvenProductOrUnknown.HOME,
    [AvenCardProductType.ASSET_ATTESTATION]: avenProduct_1.AvenProductOrUnknown.UCC,
    [AvenCardProductType.AUTO]: avenProduct_1.AvenProductOrUnknown.AUTO,
    [AvenCardProductType.AUTO_REVOLVING_FIRST]: avenProduct_1.AvenProductOrUnknown.AUTO,
    [AvenCardProductType.CRYPTO]: avenProduct_1.AvenProductOrUnknown.CRYPTO,
    [AvenCardProductType._NONE]: avenProduct_1.AvenProductOrUnknown.UNKNOWN,
};
